export const GET_USER_INFO = 'GET_USER_INFO' as const;
export const GET_USER_INFO_PENDING = 'GET_USER_INFO_PENDING' as const;
export const GET_USER_INFO_FULFILLED = 'GET_USER_INFO_FULFILLED' as const;
export const GET_USER_INFO_REJECTED = 'GET_USER_INFO_REJECTED' as const;
export const GET_USER_LOCATIONS = 'GET_USER_LOCATIONS' as const;
export const GET_USER_LOCATIONS_PENDING = 'GET_USER_LOCATIONS_PENDING' as const;
export const GET_USER_LOCATIONS_FULFILLED = 'GET_USER_LOCATIONS_FULFILLED' as const;
export const GET_USER_LOCATIONS_REJECTED = 'GET_USER_LOCATIONS_REJECTED' as const;
export const GET_USER_INTERESTS = 'GET_USER_INTERESTS' as const;
export const GET_USER_INTERESTS_PENDING = 'GET_USER_INTERESTS_PENDING' as const;
export const GET_USER_INTERESTS_FULFILLED = 'GET_USER_INTERESTS_FULFILLED' as const;
export const GET_USER_INTERESTS_REJECTED = 'GET_USER_INTERESTS_REJECTED' as const;
export const GET_USER_PUSHES_STATS = 'GET_USER_PUSHES_STATS' as const;
export const GET_USER_PUSHES_STATS_PENDING = 'GET_USER_PUSHES_STATS_PENDING' as const;
export const GET_USER_PUSHES_STATS_FULFILLED = 'GET_USER_PUSHES_STATS_FULFILLED' as const;
export const GET_USER_PUSHES_STATS_REJECTED = 'GET_USER_PUSHES_STATS_REJECTED' as const;
export const GET_USER_RECENT_ACTIVITIES = 'GET_USER_RECENT_ACTIVITIES' as const;
export const GET_USER_RECENT_ACTIVITIES_PENDING = 'GET_USER_RECENT_ACTIVITIES_PENDING' as const;
export const GET_USER_RECENT_ACTIVITIES_FULFILLED = 'GET_USER_RECENT_ACTIVITIES_FULFILLED' as const;
export const GET_USER_RECENT_ACTIVITIES_REJECTED = 'GET_USER_RECENT_ACTIVITIES_REJECTED' as const;
export const GET_USER_DAILY_ACTIVITIES_DETAILS = 'GET_USER_DAILY_ACTIVITIES_DETAILS' as const;
export const GET_USER_DAILY_ACTIVITIES_DETAILS_PENDING = 'GET_USER_DAILY_ACTIVITIES_DETAILS_PENDING' as const;
export const GET_USER_DAILY_ACTIVITIES_DETAILS_FULFILLED = 'GET_USER_DAILY_ACTIVITIES_DETAILS_FULFILLED' as const;
export const GET_USER_DAILY_ACTIVITIES_DETAILS_REJECTED = 'GET_USER_DAILY_ACTIVITIES_DETAILS_REJECTED' as const;
export const GET_USER_ARTICLES = 'GET_USER_ARTICLES' as const;
export const GET_USER_ARTICLES_PENDING = 'GET_USER_ARTICLES_PENDING' as const;
export const GET_USER_ARTICLES_FULFILLED = 'GET_USER_ARTICLES_FULFILLED' as const;
export const GET_USER_ARTICLES_REJECTED = 'GET_USER_ARTICLES_REJECTED' as const;
export const GET_RELATED_USER_IDS = 'GET_RELATED_USER_IDS' as const;
export const GET_RELATED_USER_IDS_PENDING = 'GET_RELATED_USER_IDS_PENDING' as const;
export const GET_RELATED_USER_IDS_FULFILLED = 'GET_RELATED_USER_IDS_FULFILLED' as const;
export const GET_RELATED_USER_IDS_REJECTED = 'GET_RELATED_USER_IDS_REJECTED' as const;
export const GET_USER_FANS = 'GET_USER_FANS' as const;
export const GET_USER_FANS_PENDING = 'GET_USER_FANS_PENDING' as const;
export const GET_USER_FANS_FULFILLED = 'GET_USER_FANS_FULFILLED' as const;
export const GET_USER_FANS_REJECTED = 'GET_USER_FANS_REJECTED' as const;
